import {Routes} from '@angular/router';
import {MainLayoutComponent} from "./core/layouts/main-layout/main-layout.component";
import {MsalGuard} from "@azure/msal-angular";

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        title: 'Home | SSBA',
        loadComponent: () => import("./feature/home/page/home.component")
          .then(component => component.HomeComponent),
      },
      {
        path: 'users',
        title: 'Users | SSBA',
        loadComponent: () => import("./feature/users/page/users.component")
          .then(component => component.UsersComponent),
      },
      {
        path: 'audit-logs',
        title: 'Audit Logs | SSBA',
        loadComponent: () => import("./feature/audit-logs/audit-logs.component")
          .then(component => component.AuditLogsComponent),
      },
      {
        path: 'modules',
        title: 'Modules | SSBA',
        loadChildren: () => import("./feature/modules/module.routes")
          .then(feature => feature.MODULES_ROUTES),
      },
      {
        path: "**",
        title: 'SSBA',
        loadComponent: () => import("./feature/not-found/page/not-found.component")
          .then(component => component.NotFoundComponent)
      }
    ],
  },
]
